import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, SecurityContext } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { ActivatedRoute, Router , NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { SharedPopupService } from '../../services/shared-popup.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LandingService } from 'src/app/core/services/landing.service';
import { shouldShowBellIcon } from '../../bell-icon-routes.util';
import { filter } from 'rxjs/operators';
import { AlertNotificationService } from 'src/app/modules/alert-management/Services/alert-notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header-settings',
  templateUrl: './header-settings.component.html',
  styleUrls: ['./header-settings.component.css']
})
export class HeaderSettingsComponent implements OnInit, OnDestroy {
  // Notification state
  showNotificationPanel: boolean = false;
  hasNewNotifications: boolean = false;
  notificationCount: number = 0;

  triggerNew: boolean = false;
  toggleSetting: boolean = false;
  @Input() settingIconShown: boolean = true;
  @Input() helpGuide: boolean = false;
  @Input() showExcel: boolean = false;
  @Input() showPPT: boolean = false;
  @Input() excelExport: boolean = false;
  @Input() pptExport: boolean = false;
  @Input() repository: boolean = false;
  @Input() exportDownloads: boolean = false;
  @Input() userManagementShown: boolean = false;
  @Input() lowBaseIdentifier: boolean = false;
  @Input() exportReportInput!: ExcelExportReportInputs;
  @Input() logout:boolean=true;
  @Input() Home:boolean=true;
  @Input() isHeader:boolean=true;
  @Input() moduleName: string = '';
  showBellIcon! : boolean;
  isUserManagement:boolean=false;
  guideUrl = environment.UserGuideUrl;
  receivedBoolValue: boolean = false;
  showExportsDownloadsPopup: boolean = false;
  @Output() excelExportClick = new EventEmitter<void>();
  @Output() pptExportClick = new EventEmitter<void>();
  @Output() documentRepoClick = new EventEmitter<void>();
  @Output() OnSettingsSel = new EventEmitter<string>();
  @Input() docClick: boolean = true;
  @Input() hasDocuments: boolean = false;
  
  notifications: any[] = [];
  subscriptions: Subscription[] = [];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef,
    private _authenticateService: AuthenticationService,
    private sharedPopup: SharedPopupService,
    private sanitizer: DomSanitizer,
    private landingService: LandingService,
    private notificationService: AlertNotificationService,
  ) { }
  
  ngOnInit(): void {
    this.showBellIcon = this.landingService.getAlertAccess() && shouldShowBellIcon(this.router.url);
    // navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const navEvent = event as NavigationEnd;
        this.showBellIcon = this.landingService.getAlertAccess() && shouldShowBellIcon(navEvent.urlAfterRedirects);
      });
   
    let accessLevel = this._authenticateService.GetAccess();
    if (accessLevel != null) {
      if (accessLevel == this._authenticateService.level1 || accessLevel == this._authenticateService.level2) {
        this.isUserManagement = true;
      }
    }

    this.subscriptions.push(this.notificationService.hasNotifications$.subscribe(value => {
      this.hasNewNotifications = value;
    }));

    this.checkNotifications();
  }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    // Check if the clicked element is outside the component
    if (!this.el.nativeElement.contains(event.target)) {
      this.toggleSetting = false;
    }
  }
  
  getSanitizedHtml(html: string): SafeHtml {
    return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
  }

  stripHtml(text: string): string {
    return text.replace(/<[^>]*>/g, '');
  }

  /**
   * Handle notification count changes from the panel
   */
  onNotificationCountChange(count: number): void {
    this.notificationCount = count;
    this.hasNewNotifications = count > 0;
  }

  redirectToLandingPage() {
    localStorage.clear();
    this.router.navigate(['/landing']);
  }
  onUserManagementClick() {
    this.router.navigate(['/user-management']);
  }
  OnSettingClick() {
    this.toggleSetting = !this.toggleSetting;
  }
  OnClickExcelExport() {
    this.excelExportClick.emit();
    this.toggleSetting = false;
  }
  onUserGuideClick() {
    const guideUrl = this.guideUrl;
    window.open(guideUrl, '_blank');
  }
  OnExportsDownloads() {
    this.showExportsDownloadsPopup = true;
  }
  onCloseExportDownloads() {
    this.showExportsDownloadsPopup = false;
  }

  HandleDocumentClick() {
    this.documentRepoClick.emit();
    this.toggleSetting = false;
  }
  
  checkNotifications() {
    if (!this.showBellIcon) {
     return;
    }
    
    const study = this.landingService.getSelectedStudy() ?? '';
    const client = this.landingService.getSelectedClient() ?? '';
    const userEmail = localStorage.getItem('useremail') ?? '';
    
    if (!study || !client || !userEmail) return;
    
    this.sharedPopup.getTriggeredAlertList(userEmail, client, study).subscribe((value: any) => {
      const parsedData = JSON.parse(value.Data);
      this.notificationCount = parsedData.TriggeredAlerts.totalCount || 0;
      if (this.notificationCount > 0) {
        this.hasNewNotifications = true;
      }
    });
  }

  /**
   * Toggle notification panel open/close
   */
  toggleNotificationPanel(): void {
    this.showNotificationPanel = !this.showNotificationPanel;
  }

  ExportToPPT() {
    this.pptExportClick.emit();
    this.toggleSetting = false;
  }
  LogOut() {
    this._authenticateService.logout();
  }

  settingOptionSel(item : any){
    this.toggleSetting = false;
    this.OnSettingsSel.emit(item);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
